import './profile.css';
import {
  DICE_ORDER,
  DISCOVERY_ORDER,
  DICE_CATEGORIES,
  EXPERTISE_DATA,
} from './content/expertise.js';

/**
 * Landing page "perfil completo": renderiza TODAS as categorias e itens de uma
 * vez, a partir da mesma fonte de conteúdo usada na experiência 3D
 * (`content/expertise.js`). Assim, ao preencher os placeholders lá, esta página
 * atualiza junto — sem duplicação de conteúdo.
 */

const escapeHtml = (str) =>
  String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const sectionId = (type) => `cat-${type}`;

function renderStats() {
  const el = document.getElementById('profile-stats');
  if (!el) return;
  const totalItems = DICE_ORDER.reduce(
    (sum, type) => sum + Object.keys(EXPERTISE_DATA[type].entries).length,
    0,
  );
  el.textContent = `${DICE_ORDER.length} dados · ${totalItems} descritivos técnicos`;
}

function renderToc() {
  const toc = document.getElementById('profile-toc');
  if (!toc) return;
  toc.innerHTML = DISCOVERY_ORDER.map((type) => {
    const cat = DICE_CATEGORIES[type];
    return (
      `<a class="profile-toc__link" href="#${sectionId(type)}">` +
      `<span class="profile-toc__die">${escapeHtml(cat.label)}</span>` +
      `<span class="profile-toc__name">${escapeHtml(cat.short)}</span>` +
      `</a>`
    );
  }).join('');
}

function renderSections() {
  const main = document.getElementById('profile-main');
  if (!main) return;

  main.innerHTML = DISCOVERY_ORDER.map((type) => {
    const cat = DICE_CATEGORIES[type];
    const die = EXPERTISE_DATA[type];
    const keys = Object.keys(die.entries);

    const cards = keys
      .map((key) => {
        const entry = die.entries[key];
        const isDraft = entry.placeholder === true;
        const text = entry.text
          ? `<p class="profile-card__text">${escapeHtml(entry.text)}</p>`
          : '';
        return (
          `<article class="profile-card${isDraft ? ' profile-card--draft' : ''}">` +
          `<div class="profile-card__head">` +
          `<h3 class="profile-card__title">${escapeHtml(entry.title)}</h3>` +
          `</div>` +
          text +
          `</article>`
        );
      })
      .join('');

    return (
      `<section class="profile-section" id="${sectionId(type)}">` +
      `<header class="profile-section__head">` +
      `<span class="profile-section__die">${escapeHtml(cat.label)}</span>` +
      `<div>` +
      `<h2 class="profile-section__title">${escapeHtml(cat.name)}</h2>` +
      `<p class="profile-section__thesis">${escapeHtml(cat.thesis ?? '')}</p>` +
      `<p class="profile-section__count">${keys.length} ${keys.length === 1 ? 'descritivo' : 'descritivos'}</p>` +
      `</div>` +
      `</header>` +
      `<div class="profile-grid">${cards}</div>` +
      `</section>`
    );
  }).join('');
}

renderStats();
renderToc();
renderSections();
